import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-primary-container',
    templateUrl: './primary-container.component.html',
    styleUrls: ['./primary-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PrimaryContainerComponent {
    @Input() content: {
        title?: string;
        subtitle?: string;
    } = {};

    @Input() type: 'h1' | 'paragraph' = 'h1';

    @Input() containerType: 'container' | 'container-fluid' = 'container';

    @Input() containerGutter: 'g-0' | string = 'g-0';

    @Input() containerClass: '' | string = '';
}
